import { loadingBoardFailedMessage } from '../CalendarBoard.locstring.json';
import { getLogicalRing } from 'owa-config';
import loc from 'owa-localize';

export const CALENDAR_BOARD_CONFIG = {
    // TODO VSO 107397: Disable feedback button for all rings once Elite study is done
    enableFeedback: getLogicalRing() === 'Dogfood' || getLogicalRing() === 'Microsoft',
    feedbackDisplayArea: 'Calendar Board',
    enableCanvasLock: true,
    getLoadingAssetsFailedMessage: () => loc(loadingBoardFailedMessage),
};
